import { FC } from "react";
import { IconProps } from "utils/interfaces";

export const Institution: FC<IconProps> = ({ color }) => {
  return (
    <svg
      width="66"
      height="62"
      viewBox="0 0 66 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33 7L58 17.0714V20.4286H54.6667C54.6667 20.8832 54.4887 21.2766 54.1328 21.6088C53.7769 21.941 53.3559 22.1071 52.8698 22.1071H13.1302C12.6441 22.1071 12.2231 21.941 11.8672 21.6088C11.5113 21.2766 11.3333 20.8832 11.3333 20.4286H8V17.0714L33 7ZM14.6667 23.7857H21.3333V43.9286H24.6667V23.7857H31.3333V43.9286H34.6667V23.7857H41.3333V43.9286H44.6667V23.7857H51.3333V43.9286H52.8698C53.3559 43.9286 53.7769 44.0947 54.1328 44.4269C54.4887 44.7591 54.6667 45.1525 54.6667 45.6071V47.2857H11.3333V45.6071C11.3333 45.1525 11.5113 44.7591 11.8672 44.4269C12.2231 44.0947 12.6441 43.9286 13.1302 43.9286H14.6667V23.7857ZM56.2031 48.9643C56.6892 48.9643 57.1102 49.1304 57.4661 49.4626C57.822 49.7948 58 50.1882 58 50.6429V54H8V50.6429C8 50.1882 8.17795 49.7948 8.53385 49.4626C8.88976 49.1304 9.31076 48.9643 9.79687 48.9643H56.2031Z"
        fill={color}
      />
    </svg>
  );
};
